export default __webpack_public_path__ + "static/media/logo_femimed.c9444e44.png";